/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgLocationResource } from '../models/LlgLocationResource';
import { LogSourceWithPolicy } from '../models/LogSourceWithPolicy';

export class LlgLocationWithResources {
  'locationResource': LlgLocationResource;
  'logSources': Array<LogSourceWithPolicy>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "locationResource",
      "baseName": "locationResource",
      "type": "LlgLocationResource",
      "format": ""
    },
    {
      "name": "logSources",
      "baseName": "logSources",
      "type": "Array<LogSourceWithPolicy>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LlgLocationWithResources.attributeTypeMap;
  }

  public constructor() {
  }
}

